module.exports = __webpack_public_path__ + "img/homeTitleW.18cf28b7.png";